module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-03-878e2c25461e558ab7ce42e3d72f8d95.svg";